import styled, { css } from 'styled-components';

export const SearchDrawerWrapper = styled.div`
  height: 100% !important;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 70px;
  gap: 0px 0px;
  align-content: center;
  justify-content: center;
`;

export const ResponsivePickerContent = styled.div<{
  isTravelPlanning?: boolean;
  $footerCanGrow?: boolean;
}>`
  height: 100% !important;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${({ $footerCanGrow }) =>
    $footerCanGrow
      ? 'auto minmax(0, 1fr) minmax(70px, auto)'
      : 'auto 1fr 70px'};
  gap: 0px 0px;
  align-content: center;
  justify-content: center;

  ${({ isTravelPlanning = false, theme }) =>
    isTravelPlanning &&
    css`
      @media ${`(max-width: ${theme.breakPoint.LARGE_1X})`} {
        grid-template-rows: auto 1fr 30px;
        row-gap: 10px;
        padding: 24px 12px;
      }
    `}
`;
